module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Two columns":"Two columns","Three columns":"Three columns"},"de":{"Two columns":"Zweispalter","Three columns":"Dreispalter"}}')
  delete Component.options._Ctor
}
